<div class="project-label">
  Project: <strong>{{activeProjectTitle}}</strong>
</div>
<div class="abstracts-label">
  Abstracts and/or complex abstract groups available to enqueue: <b>{{ model.maxAbstracts }}</b>
</div>
<div class="slider-container">
  <mat-slider
    class="slider-style"
    min="0"
    [max]="model.maxAbstracts"
    step="1"
    tickInterval="1"
    discrete
    [disabled]="model.maxAbstracts === 0"
    showTickMarks
    >
    <input (valueChange)="sliderChange($event)" matSliderThumb [(ngModel)]="sliderValue" >
  </mat-slider>
</div>
<div class="numeric-input-container">
  <mat-form-field>
    <input
           matInput
           #sliderInput
           appearance="outline"
           type="number"
           min="0"
           [max]="model.maxAbstracts"
           class="numeric-input"
           [(ngModel)]="sliderValue"
           appNumericInput
           [disabled]="model.maxAbstracts === 0"
           (change)="numericInputChange($event)" />
  </mat-form-field>
  
</div>
<div class="add-queue-button-container">
  <button mat-raised-button
          id="addBtn"
          class="btn btn-primary"
          style="margin-left:10px;"
          (click)="addQueue()"
          [disabled]="isUpdating || (!sliderInput.validity.valid) || sliderValue === 0">Enqueue</button>
</div>
